import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({
  title,
  description,
  image = "https://devhirelab.com/og-image.png", // Fallback OG image
  type = "website",
  noindex = false,
  structuredData,
}) => {
  const location = useLocation();
  const siteName = "DevHireLab";
  const baseUrl = "https://devhirelab.com";
  const currentUrl = `${baseUrl}${location.pathname}`;

  const fullTitle = title ? title : siteName;

  const defaultDescription =
    "DevHireLab is the all-in-one platform for mastering Python through interactive tutorials, live simulations, and AI-powered interviews.";

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <link rel="canonical" href={currentUrl} />

      {/* Robots Control */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title || siteName} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || siteName} />
      <meta
        name="twitter:description"
        content={description || defaultDescription}
      />
      <meta name="twitter:image" content={image} />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: siteName,
          url: baseUrl,
          logo: `${baseUrl}/favicon.svg`,
          sameAs: [
            "https://twitter.com/devhirelab",
            "https://linkedin.com/company/devhirelab",
            "https://github.com/devhirelab",
          ],
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: siteName,
          url: baseUrl,
          potentialAction: {
            "@type": "SearchAction",
            target: `${baseUrl}/tutorials?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        })}
      </script>

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
